<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>内部学生列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">
        <el-col :span="2" v-if="canLook == 1">
          <el-button type="primary" size="mini" @click="editDialogVisible = true"
            >添加</el-button
          >
        </el-col>

        <el-col :span="6">
          <el-input
            placeholder="请输入名称"
            v-model="queryInfo.query"
            clearable
            @clear="getShopList"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getShopList"
            ></el-button>
          </el-input>
        </el-col> 
      </el-row>

      <!-- 用户列表区域 -->
      <el-table
        :data="userlist"
        border
        stripe
       
      >
        <!-- <el-table-column fixed type="selection" width="55"> </el-table-column> -->
        <!-- <el-table-column type="index"></el-table-column> -->
        <el-table-column label="id" prop="id" width="50px"></el-table-column>
        <el-table-column label="学生姓名" prop="s_name" width="120px">
        </el-table-column>
        <el-table-column
          label="学校"
          prop="school"
          width="120px"
        ></el-table-column>

        <el-table-column
          label="年级"
          prop="grade"
          width="80px"
        ></el-table-column>

        <el-table-column
          label="联系电话"
          prop="phone"
          width="90px"
        ></el-table-column>

        <el-table-column
          label="来源"
          prop="source"
          width="80px"
        ></el-table-column>

        <el-table-column
          label="学习情况"
          prop="studyLevel"
          width="140px"
        ></el-table-column>

        <el-table-column
          label="申请信息"
          prop="applyInfo"
          width="140px"
        ></el-table-column>

        
        <el-table-column
          label="备注"
          prop="beizhu"
          width="150px"
        ></el-table-column>

        <el-table-column label="操作" v-if="canLook == 1">
          <template slot-scope="scope">
            <!-- <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="clickSetVip(scope.row.id)"
              >开通会员</el-button
            > -->
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="editUserById(scope.row.id)"
              >编辑信息</el-button
            >
              <el-button
              @click="removeUserById(scope.row.id)"
              type="danger"
              icon="el-icon-error"
              size="mini"
              round 
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 修改用户的对话框 -->
    <el-dialog
      title="用户信息"
      :visible.sync="editDialogVisible"
      width="50%"
      @close="editDialogClosed"
    >
      <el-form
        :model="editForm"
        :rules="editFormRules"
        ref="editFormRef"
        label-width="130px"
      >
        
        <el-form-item label="学生姓名" prop="s_name">
          <el-input v-model="editForm.s_name"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="editForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="学校" prop="school">
          <el-input v-model="editForm.school"></el-input>
        </el-form-item>
        <el-form-item label="年级" prop="grade">
          <el-input v-model="editForm.grade"></el-input>
        </el-form-item>
        <el-form-item label="来源" prop="source">
          <el-input
            v-model="editForm.source"
            placeholder="请输入来源"
          ></el-input>
        </el-form-item>
        <el-form-item label="学习情况" prop="studyLevel">
          <el-input
            v-model="editForm.studyLevel"
            placeholder="请输入学习情况"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请情况" prop="applyInfo">
          <el-input
            v-model="editForm.applyInfo"
            placeholder="请输入申请情况"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="beizhu">
          <el-input
            v-model="editForm.beizhu"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUserInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dateValue: "",
      refusetip: "",
       
      canLook: 1,
      exportUrl:
        "https://hsapi.hsxsn.cn/exportUserList?mPhone=" +
        localStorage.getItem("phone"),
      // 获取店铺列表的参数对象
      queryInfo: {
        query: "",
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 10,
      },

      userlist: [], 
      total: 0,
      
      // 控制修改用户对话框的显示与隐藏
      editDialogVisible: false,

      // 查询到的用户信息对象
      editForm: {
        id: "",
        school: "",
        phone: "",
        s_name: "",
        grade: "",
        source: "",
        applyInfo: "",
        studyLevel: "",
        beizhu: null,
      },

      // 修改表单的验证规则对象
      editFormRules: { 
        s_name: [
          { required: true, message: "请输入学生姓名", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
      }, 
      multipleSelection: [],
      multipleSelectionjson: null,
    };
  },

  created() {
    this.getShopList();
    // this.getUserRoleList()
    // this.getSalemansList()
  },

  methods: {
 
   
    async getShopList() {
      if (window.sessionStorage.getItem("pathCanLook") == 2) {
        //仅查看
        this.canLook = 2;
      }
      const { data: res } = await this.$http.get("admin/insideUsers/getList", {
        params: this.queryInfo,
      });
      if (res.code !== 200) {
        return this.$message.error("暂无用户！");
      }
      console.log(res);
      this.userlist = res.result.list;
      this.total = res.result.count;
    },

   
    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.pagesize = newSize;
      this.getShopList();
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      // console.log(newPage);
      this.queryInfo.pagenum = newPage;
      this.getShopList();
    },

    // 监听添加用户对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields();
    },

    // 点击按钮，添加新用户
    addUser() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;
        // 可以发起添加用户的网络请求
        const { data: res } = await this.$http.post(
          "admin/insideUsers/addInfo",
          this.addForm
        );
        if (res.code !== 200) {
          this.$message.error(res.message);
          return;
        }
        this.$message.success(res.message);
        // 隐藏添加用户的对话框
        this.addDialogVisible = false;
        // 重新获取用户列表数据
        this.getShopList();
      });
    },

    // 编辑按钮点击
    async editUserById(userId) {
      const { data: res } = await this.$http.get("/admin/insideUsers/detail", {
        params: {
          id: userId,
        },
      });
      console.log(res);
      if (res.code != 200) {
        return this.$message.error("获取信息失败");
      }
      this.editForm = res.result;
      this.editDialogVisible = true;
    },

    // 监听修改用户对话框的关闭事件
    editDialogClosed() {
      this.$refs.editFormRef.resetFields();
    },

    // 修改用户信息并提交
    editUserInfo() {
      var url =   "admin/insideUsers/addInfo";
      if(!this.editForm.id && this.editForm.id > 0){
        url =   "admin/insideUsers/editInfo";
      }
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        // 发起修改用户信息的数据请求
        const { data: res } = await this.$http.post(
          url,
          this.editForm
        );
        if (res.code !== 200) {
          return this.$message.error("更新用户信息失败！");
        }
        // 关闭对话框
        this.editDialogVisible = false;
        this.editForm.id = null;
        // 刷新数据列表
        this.getShopList();
        // 提示修改成功
        this.$message.success("更新用户信息成功！");
      });
    },

    // 根据Id删除对应的用户信息
    async removeUserById(id) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm(
        "此操作将永久删除该用户, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmResult !== "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$http.post("admin/insideUsers/delete", {
        id: id,
      });
      if (res.code !== 200) {
        return this.$message.error("删除用户失败！");
      }
      this.$message.success("删除用户成功！");
      this.getShopList();
    },
  },
};
</script>

<style lang="less" scoped>
.aaaa {
  margin-left: 10px;
}

.el-image {
  width: 49% !important;
  height: 49% !important;
}
.demonstration {
  color: red;
  font-size: 30px;
}
</style>
